export default "__VITE_ASSET__BmDsfVN3__"